import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { placeholder } from 'src/app/models/placeholder';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { HelperService } from 'src/app/services/helper/helper.service';
@Component({
  selector: 'booking-item',
  templateUrl: './booking-item.component.html',
  styleUrls: ['./booking-item.component.scss'],
})
export class BookingItemComponent implements OnInit {
  @Input() requestDetail: any;
  @Input() serviceDetails: any[];
  @Input() viewVoucherCode: any;
  public imagePlaceholder = placeholder;
  public currencyCode: string;
  public travelDate: Date;
  public serviceType: any;
  constructor(
    private analyticsService: AnalyticsService,
    private helperService: HelperService,
    private navCtrl: NavController,
  ) {}

  ngOnInit() {
    this.currencyCode = this.requestDetail?.currency;
    this.travelDate = this.helperService.convertToLocalTimezoneDate(
      this.requestDetail?.travelDate?.date
    );
    const serviceId = this.requestDetail?.serviceId;
    if (serviceId && serviceId in this.serviceDetails) {
      this.serviceType = this.serviceDetails[serviceId];
    } else {
      console.log('Invalid serviceId or serviceDetails does not contain the requested serviceId');
    }
  };

  handleBookingAccordionAction(requestDetail) {
    this.analyticsService.trackUnified('accordion_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'button_clicked',
      component: 'booking-item-component',
      button: 'accordion-button',
    });
  }

  redirectToCodePage(){
    let url ='';
    if (this.serviceType?.type === 'restaurant') {
       url = `/restaurant/${this.requestDetail?.serviceId}`;
    }else if(this.serviceType?.type === 'gym'){
       url = `/gym/${this.requestDetail?.serviceId}`;
    }
    this.navCtrl.navigateForward([url]);
  }
}
